import React, { Component } from 'react';
import Dashboard from './Dashboard';
import ProjectList from './Project/ProjectList';
import PersonalInfo from './PersonalInfo';
import Subscription from './Subscription/Subscription';

export { ProjectList, Dashboard, PersonalInfo, Subscription };

export default class Account extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
            <div className="container py-5">
                <div className="row">
                    <div className="col-md-6 mx-auto">
                        {this.props.children}
                    </div>
                </div>
            </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Account/index.js